<template>
  <div class="main">
    <Header
      :show="true"
      title="业务"
      left=""
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div>
      <van-cell-group v-if="checkPermission([11, 21, 31, 41, 421, 428])">
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <!-- <div style="width: 4px; height: 2.2vh; background-color: #EA7E2D; border-radius: .6vw; float: left; margin-top: 2px;" /> -->
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >业务处理</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          v-if="checkPermission([11])"
          :icon="imageSrc.iconYeWuYueYuShenHe"
          text="预约审核"
          to="/service/business/verify"
        />
        <van-grid-item
          v-if="checkPermission([21])"
          :icon="imageSrc.iconYeWuShuiFenJianCe"
          text="水份检测"
          to="/service/business/water"
        />
        <van-grid-item
          v-if="checkPermission([31])"
          :icon="imageSrc.iconYeWuFenLiaoJianCe"
          text="粉料检测"
          to="/service/business/material"
        />
        <van-grid-item
          v-if="checkPermission([41])"
          :icon="imageSrc.iconYeWuHuoChePaiDui"
          text="货车排队"
          to="/service/business/queue"
        />
        <van-grid-item
          v-if="checkPermission([421])"
          :icon="imageSrc.iconJiaYouShenQing"
          text="加油申请"
          to="/service/business/vehicle"
        />
        <van-grid-item
          v-if="checkPermission([428])"
          :icon="imageSrc.iconShenHeJiaYouShenQing"
          text="审核加油申请"
          to="/service/business/vehicle-apply"
        />
      </van-grid>

      <div
        v-if="checkPermission([51, 311, 251, 61])"
        style="height: 8px; background-color: #f8f8f8"
      />
      <van-cell-group v-if="checkPermission([51, 311, 251, 61])">
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >设备控制</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          v-if="checkPermission([51])"
          :icon="imageSrc.iconKongZhiRenLianZhaJi"
          text="人脸闸机"
          to="/service/control/face"
        />
        <van-grid-item
          v-if="checkPermission([311])"
          :icon="imageSrc.iconKongZhiCheLiangDaoZha"
          text="车辆道闸"
          to="/service/control/car"
        />
        <van-grid-item
          v-if="checkPermission([251])"
          :icon="imageSrc.iconKongZhiDiBangDaoZha"
          text="地磅道闸"
          to="/service/control/weigh"
        />
        <van-grid-item
          v-if="checkPermission([61])"
          :icon="imageSrc.iconKongZhiXieLiaoGuanKou"
          text="卸料罐口"
          to="/service/control/port"
        />
      </van-grid>

      <div
        v-if="checkPermission([71, 81, 91, 301, 261, 281, 291, 441, 431])"
        style="height: 8px; background-color: #f8f8f8"
      />
      <van-cell-group
        v-if="checkPermission([71, 81, 91, 301, 261, 281, 291, 441, 431])"
      >
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >历史记录</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          v-if="checkPermission([71])"
          :icon="imageSrc.iconLiShiRenLianZhaJi"
          text="人脸闸机"
          to="/service/history/face"
        />
        <van-grid-item
          v-if="checkPermission([81])"
          :icon="imageSrc.iconLiShiCheLiangDaoZha"
          text="车辆道闸"
          to="/service/history/car"
        />
        <van-grid-item
          v-if="checkPermission([91])"
          :icon="imageSrc.iconLiShiWuRenGuoBang"
          text="无人过磅"
          to="/service/history/weigh"
        />
        <van-grid-item
          v-if="checkPermission([301])"
          :icon="imageSrc.iconLiShiLiaoCangXieLiao"
          text="料仓卸料"
          to="/service/history/store"
        />
        <van-grid-item
          v-if="checkPermission([261])"
          :icon="imageSrc.iconLiShiGuanKouXieLiao"
          text="罐口卸料"
          to="/service/history/port"
        />
        <van-grid-item
          v-if="checkPermission([281])"
          :icon="imageSrc.iconLiShiShangTongZhuangChe"
          text="商砼装车"
          to="/service/history/line"
        />
        <van-grid-item
          v-if="checkPermission([191])"
          :icon="imageSrc.iconLiShiWuLiaoPanDian"
          text="物料盘点"
          to="/service/history/material"
        />
        <van-grid-item
          v-if="checkPermission([441])"
          :icon="imageSrc.iconJiaYouJiLu"
          text="加油记录"
          to="/service/history/refuel"
        />
        <van-grid-item
          v-if="checkPermission([431])"
          :icon="imageSrc.iconJiaYouBaoBiao"
          text="加油报表"
          to="/service/history/refuel-report"
        />
      </van-grid>

      <div
        v-if="checkPermission([101, 111, 121, 131, 271, 321])"
        style="height: 8px; background-color: #f8f8f8"
      />
      <van-cell-group v-if="checkPermission([101, 111, 121, 131, 271, 321])">
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >工程配置</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          v-if="checkPermission([101])"
          :icon="imageSrc.iconGongChengShengChanKaiGuan"
          text="生产开关"
          to="/service/project/switch"
        />
        <van-grid-item
          v-if="checkPermission([331])"
          :icon="imageSrc.iconGongChengYuYueShenHe"
          text="审核方式"
          to="/service/project/verify"
        />
        <van-grid-item
          v-if="checkPermission([321])"
          :icon="imageSrc.iconGongChengBanGongDaoZha"
          text="办公道闸"
          to="/service/project/car"
        />
        <van-grid-item
          v-if="checkPermission([111])"
          :icon="imageSrc.iconGongChengXiaoXiTuiSong"
          text="消息推送"
          to="/service/project/message"
        />
        <van-grid-item
          v-if="checkPermission([271])"
          :icon="imageSrc.iconGongChengGuLiaoCheShu"
          text="骨料车数"
          to="/service/project/number"
        />
        <van-grid-item
          v-if="checkPermission([121])"
          :icon="imageSrc.iconGongChengZhuangCheXian"
          text="装车线"
          to="/service/project/line"
        />
        <van-grid-item
          v-if="checkPermission([131])"
          :icon="imageSrc.iconGongChengXieLiaoGuanKou"
          text="卸料罐口"
          to="/service/project/port"
        />
      </van-grid>

      <div
        v-if="checkPermission([141, 151, 161, 171, 181, 191, 201, 401])"
        style="height: 8px; background-color: #f8f8f8"
      />
      <van-cell-group
        v-if="checkPermission([141, 151, 161, 171, 181, 191, 201, 401])"
      >
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >系统设置</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          v-if="checkPermission([141])"
          :icon="imageSrc.iconXiTongYongHuLieBiao"
          text="用户列表"
          to="/service/system/staff"
        />
        <van-grid-item
          v-if="checkPermission([151])"
          :icon="imageSrc.iconXiTongBuMenLieBiao"
          text="部门列表"
          to="/service/system/department"
        />
        <van-grid-item
          v-if="checkPermission([161])"
          :icon="imageSrc.iconXiTongJueSeLieBiao"
          text="角色列表"
          to="/service/system/role"
        />
        <van-grid-item
          v-if="checkPermission([171])"
          :icon="imageSrc.iconXiTongHuoCheLieBiao"
          text="货车列表"
          to="/service/system/truck"
        />
        <van-grid-item
          v-if="checkPermission([181])"
          :icon="imageSrc.iconXiTongGongYingShangLieBiao"
          text="供应商列表"
          to="/service/system/supplier"
        />
        <van-grid-item
          v-if="checkPermission([191])"
          :icon="imageSrc.iconXiTongChanPinLieBiao"
          text="产品列表"
          to="/service/system/product"
        />
        <van-grid-item
          v-if="checkPermission([201])"
          :icon="imageSrc.iconXiTongWuLiaoLieBiao"
          text="物料列表"
          to="/service/system/material"
        />
        <van-grid-item
          v-if="checkPermission([401])"
          :icon="imageSrc.iconCheLiangGuanLi"
          text="车辆列表"
          to="/service/system/vehicle"
        />
      </van-grid>

      <div style="height: 8px; background-color: #f8f8f8" />
      <van-cell-group>
        <van-cell center>
          <template #title>
            <div style="display: flex; align-items: center; padding: 5px 0">
              <img
                :src="imageSrc.gridHeaderLeft"
                style="width: 20px; height: 20px"
              />
              <span
                style="font-size: 3.8vw; padding: 0.5vw 0 0 1.6vw; color: #000"
                >我的设置</span
              >
            </div>
          </template>
        </van-cell>
      </van-cell-group>
      <van-grid :column-num="4">
        <van-grid-item
          :icon="imageSrc.iconWoDeXiuGaiMiMa"
          text="修改密码"
          to="/service/user/password"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeCaoZuoShouCe"
          text="操作手册"
          @click="handleClickManualDownload"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeCaoZuoShouCe"
          text="加油申请说明"
          to="/service/manual/apply"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeCaoZuoShouCe"
          text="加油管理说明"
          to="/service/manual/manager"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeCaoZuoShouCe"
          text="加油管理说明"
          to="/service/manual/system"
        />
        <van-grid-item
          v-if="checkPermission([221])"
          :icon="imageSrc.iconWoDeYunXingRiZhi"
          text="运行日志"
          to="/service/user/log"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeGuanYuWoMen"
          text="关于我们"
          @click="handleClickCellAboutUs"
        />
        <van-grid-item
          :icon="imageSrc.iconWoDeTuiChuDengLu"
          text="退出登录"
          @click="handleClickCellExit"
        />
        <van-uploader
          :max-count="1"
          :deletable="false"
          :before-read="beforeRead"
          :after-read="afterRead"
        >
          <van-grid-item
            :icon="imageSrc.iconWoDeYongHuTouXiang"
            text="用户头像"
            @click="handleClickUpdateAvatar"
          />
        </van-uploader>
        <!-- <van-grid-item 
          :icon="imageSrc.iconWoDeYongHuTouXiang" 
          text="用户头像" 
          @click="handleClickUpdateAvatar"
        /> -->
      </van-grid>
      <div style="height: 3.8rem; background-color: #f8f8f8" />
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import * as imageConversion from "image-conversion";
import { mapGetters } from "vuex";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import { info } from "@/config/config.json";
import { logout as userLogout } from "@/api/user.js";
import { createWhiteOne } from "@/api/staff.js";

export default {
  name: "Service",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      imageSrc: {
        gridHeaderLeft: require("@/assets/svg/gridHeaderLeft.svg"),
        iconYeWuYueYuShenHe: require("@/assets/svg/iconYeWuYueYuShenHe.svg"),
        iconYeWuShuiFenJianCe: require("@/assets/svg/iconYeWuShuiFenJianCe.svg"),
        iconYeWuFenLiaoJianCe: require("@/assets/svg/iconYeWuFenLiaoJianCe.svg"),
        iconYeWuHuoChePaiDui: require("@/assets/svg/iconYeWuHuoChePaiDui.svg"),
        iconKongZhiRenLianZhaJi: require("@/assets/svg/iconKongZhiRenLianZhaJi.svg"),
        iconKongZhiCheLiangDaoZha: require("@/assets/svg/iconKongZhiCheLiangDaoZha.svg"),
        iconKongZhiDiBangDaoZha: require("@/assets/svg/iconKongZhiDiBangDaoZha.svg"),
        iconKongZhiXieLiaoGuanKou: require("@/assets/svg/iconKongZhiXieLiaoGuanKou.svg"),
        iconLiShiRenLianZhaJi: require("@/assets/svg/iconLiShiRenLianZhaJi.svg"),
        iconLiShiCheLiangDaoZha: require("@/assets/svg/iconLiShiCheLiangDaoZha.svg"),
        iconLiShiYuanLiaoDaoZha: require("@/assets/svg/iconLiShiYuanLiaoDaoZha.svg"),
        iconLiShiWuRenGuoBang: require("@/assets/svg/iconLiShiWuRenGuoBang.svg"),
        iconLiShiWuLiaoPanDian: require("@/assets/svg/iconLiShiWuLiaoPanDian.svg"),
        iconLiShiGuanKouXieLiao: require("@/assets/svg/iconLiShiGuanKouXieLiao.svg"),
        iconLiShiLiaoCangXieLiao: require("@/assets/svg/iconLiShiLiaoCangXieLiao.svg"),
        iconLiShiShangTongZhuangChe: require("@/assets/svg/iconLiShiShangTongZhuangChe.svg"),
        iconGongChengShengChanKaiGuan: require("@/assets/svg/iconGongChengShengChanKaiGuan.svg"),
        iconGongChengYuYueShenHe: require("@/assets/svg/iconGongChengYuYueShenHe.svg"),
        iconGongChengBanGongDaoZha: require("@/assets/svg/iconGongChengBanGongDaoZha.svg"),
        iconGongChengXiaoXiTuiSong: require("@/assets/svg/iconGongChengXiaoXiTuiSong.svg"),
        iconGongChengZhuangCheXian: require("@/assets/svg/iconGongChengZhuangCheXian.svg"),
        iconGongChengXieLiaoGuanKou: require("@/assets/svg/iconGongChengXieLiaoGuanKou.svg"),
        iconGongChengGuLiaoCheShu: require("@/assets/svg/iconGongChengGuLiaoCheShu.svg"),
        iconXiTongYongHuLieBiao: require("@/assets/svg/iconXiTongYongHuLieBiao.svg"),
        iconXiTongBuMenLieBiao: require("@/assets/svg/iconXiTongBuMenLieBiao.svg"),
        iconXiTongJueSeLieBiao: require("@/assets/svg/iconXiTongJueSeLieBiao.svg"),
        iconXiTongHuoCheLieBiao: require("@/assets/svg/iconXiTongHuoCheLieBiao.svg"),
        iconXiTongGongYingShangLieBiao: require("@/assets/svg/iconXiTongGongYingShangLieBiao.svg"),
        iconXiTongChanPinLieBiao: require("@/assets/svg/iconXiTongChanPinLieBiao.svg"),
        iconXiTongWuLiaoLieBiao: require("@/assets/svg/iconXiTongWuLiaoLieBiao.svg"),
        iconWoDeXiuGaiMiMa: require("@/assets/svg/iconWoDeXiuGaiMiMa.svg"),
        iconWoDeCaoZuoShouCe: require("@/assets/svg/iconWoDeCaoZuoShouCe.svg"),
        iconWoDeYunXingRiZhi: require("@/assets/svg/iconWoDeYunXingRiZhi.svg"),
        iconWoDeGuanYuWoMen: require("@/assets/svg/iconWoDeGuanYuWoMen.svg"),
        iconWoDeTuiChuDengLu: require("@/assets/svg/iconWoDeTuiChuDengLu.svg"),
        iconWoDeYongHuTouXiang: require("@/assets/jpg/iconWoDeYongHuTouXiang.jpg"),
        iconJiaYouShenQing: require("@/assets/svg/iconJiaYouShenQing.svg"),
        iconShenHeJiaYouShenQing: require("@/assets/svg/iconShenHeJiaYouShenQing.svg"),
        iconJiaYouBaoBiao: require("@/assets/svg/iconJiaYouBaoBiao.svg"),
        iconJiaYouJiLu: require("@/assets/svg/iconJiaYouJiLu.svg"),
        iconCheLiangGuanLi: require("@/assets/svg/iconCheLiangGuanLi.svg"),
      },
      loading: false,
      listQuery: {
        serial: null,
        username: "",
        name: "上犹万年青",
        phone: "",
        discribe: "心怀信仰，沐浴阳光",
        image: [require("@/assets/user/header.jpg")],
        avatar: require("@/assets/user/header.jpg"),
        gate: 3,
        file: null,
        reason: "员工绿色通道",
        startDate: new Date().getTime(),
        endDate: new Date().getTime(),
        validEnable: 1,
      },
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      baseUrl: "",
      manualUrl: info["manual-address"],
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
      username: "user/username",
      name: "user/name",
      phone: "user/phone",
      discribe: "user/discribe",
      avatar: "user/avatar",
    }),
  },
  watch: {},
  beforeCreate() {},
  created() {
    const url = window.location.href;
    this.baseUrl = url.substr(0, url.indexOf("/sywnq")) + "/sywnq";
    const avatar = this.baseUrl + this.avatar;
    console.log(avatar);
    this.listQuery.image = [];
    if (this.avatar !== "" && this.avatar !== null) {
      this.listQuery.image.push(avatar);
      this.listQuery.avatar = avatar;
      this.imageSrc.iconWoDeYongHuTouXiang = avatar;
    }
    const userid = this.userid;
    if (userid !== null) {
      this.listQuery.serial = userid;
    }
    const username = this.username;
    if (username !== "" && username !== null) {
      this.listQuery.username = username;
    }
    const name = this.name;
    if (name !== "" && name !== null) {
      this.listQuery.name = name;
    }
    const phone = this.phone;
    if (phone !== "" && phone !== null) {
      this.listQuery.phone = phone;
    }
    const discribe = this.discribe;
    if (discribe !== "" && discribe !== null) {
      this.listQuery.discribe = discribe;
    }
    console.log(this.listQuery);
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      // this.$router.go(-1)
      console.log("dashboard-left");
    },
    handleClickRight() {
      console.log("dashboard-right");
    },
    handleClickManualDownload() {
      window.open(this.manualUrl, "_blank");
    },
    handleClickUpdatePassword() {
      this.$router.push({
        path: "/user/password",
        query: {
          username: this.listQuery.username,
        },
      });
    },
    handleClickCellAboutUs() {
      window.open(info["official-site"], "_blank");
    },
    beforeRead(file) {
      if (file.type !== "image/jpeg") {
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          300,
          null,
          "请上传 jpg 格式图片"
        );
        return false;
      }
      return true;
    },
    afterRead(file) {
      console.log("怎么了这是？");
      return new Promise((resolve, reject) => {
        let isLt2M = file.file.size / 1024 / 1024 < 0.2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          this.listQuery.file = file.file;
          console.log("大小正合适");
          this.handleClickUpdateAvatar();
          resolve(file);
        } else {
          const scale = parseFloat(
            1 / (file.file.size / 1024 / 1024 / 0.2)
          ).toFixed(2);
          imageConversion
            .compressAccurately(file.file, {
              size: 180,
              // scale: scale,
              width: 640,
            })
            .then((res) => {
              this.listQuery.file = res;
              console.log("压缩比较好");
              this.handleClickUpdateAvatar();
              resolve(res);
            });
        }
      });
    },
    handleClickUpdateAvatar() {
      this.handleClickCreateAvatar();
    },
    handleClickCreateAvatar() {
      let data = new FormData();
      data.append("name", this.listQuery.name);
      data.append("phone", this.listQuery.phone);
      data.append("gate", this.listQuery.gate);
      data.append("image", this.listQuery.file);
      data.append("reason", this.listQuery.reason);
      data.append("startDate", this.listQuery.startDate);
      data.append("endDate", this.listQuery.endDate);
      data.append("validEnable", this.listQuery.validEnable);
      this.loading = true;
      createWhiteOne(data, this.listQuery.serial)
        .then((response) => {
          const { data } = response;
          showPhoneAlarm(
            true,
            "toast",
            null,
            2000,
            data.code,
            "添加人脸信息",
            data.message
          );
          this.loading = false;
        })
        .catch(function (error) {
          this.loading = false;
          console.error(error);
        });
    },
    handleClickCellExit() {
      Dialog.confirm({
        title: "确认退出登录？",
        message: "再次访问需要重新登录",
      })
        .then(() => {
          userLogout()
            .then((response) => {
              // const { data } = response
              this.$store.dispatch("user/logout");
              this.$router.push({
                path: "/login",
              });
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "退出登录", "取消");
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
.van-cell {
  padding: 1.5vw 3vw;
}
::v-deep .van-cell__label {
  width: 60vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
